<div
	*ngIf="isMultiSelectEnabled"
	class="m-t-1 mb-neg-1 p-0-5 font-size-12 label-text-light"
	fxLayout="row"
	fxLayoutAlign="end center"
>
	Shift + Click to multi-select
</div>
<div fxLayout="row">
	<div fxFlex="100">
		<mat-card
			*ngFor="let project of projectsViewList; let i = index"
			[ngClass]="{
				'panel-selected mat-elevation-z4':
					isMultiSelectEnabled && selectedProjectIDs.indexOf(project.id) > -1
			}"
			class="custom-panel mat-elevation-z1 primary-text primary-border project-card font-size-14 m-t-1"
		>
			<div
				(click)="openCard(i); panelClicked(project, $event)"
				(keydown.arrowdown)="$event.stopImmediatePropagation()"
				(keydown.arrowup)="$event.stopImmediatePropagation()"
				(keydown.enter)="$event.stopImmediatePropagation()"
				class="cursor-pointer"
			>
				<div fxFlex>
					<div fxLayout="row" fxLayoutGap="2rem">
						<div fxFlex fxLayout="row" fxLayoutAlign="start center">
							<app-customer-popover
								(setCustomer)="setCustomer($event, i, project.id)"
								[customerSelected]="project.customerDTO"
								fxFlex
							></app-customer-popover>
						</div>

						<div fxFlex fxLayout="row" fxLayoutAlign="start center">
							<div
								(click)="
									$event.stopImmediatePropagation();
									project.isProjectNameDisplayed = !project.isProjectNameDisplayed
								"
								*ngIf="project.showProjectName; else projectLane"
								[matTooltip]="project.isProjectNameDisplayed ? project.lanePath : project.name"
								matTooltipClass="custom-tooltip"
							>
								<span *ngIf="project.isProjectNameDisplayed">
									{{ project.name }}
								</span>
								<span *ngIf="!project.isProjectNameDisplayed">
									{{ project.lanePath }}
								</span>
								<mat-icon [inline]="true" class="primary-text w-inherit" matSuffix>
									flip_to_back
								</mat-icon>
							</div>
							<ng-template #projectLane>
								{{ project.lanePath }}
							</ng-template>
						</div>

						<div fxFlex fxLayout="row" fxLayoutAlign="center center">
							<div
								[ngClass]="{ 'fw-700': step == i }"
								class="h-100"
								fxFlex
								fxLayoutAlign="start center"
							>
								Volume:
							</div>
							<div fxFlex fxLayoutAlign="end center">
								{{
									IS_NOT_EMPTY(project.monthlyVolumeDisplay) ? project.monthlyVolumeDisplay : 'N/A'
								}}
							</div>
						</div>

						<div fxFlex fxLayout="row" fxLayoutAlign="end center">
							<div *ngIf="accountSettings.PROJECT_PROBABILITY">
								<span
									*ngIf="!utilService.isNullOrUndefined(project.probability)"
									[ngStyle]="
										getProbabilityLabelColor(
											projectHelperService.getProjectProbabilityLabel(project.probability)
										)
									"
								>
									{{ projectHelperService.getProjectProbabilityLabel(project.probability) }}
								</span>
							</div>
							<span
								(click)="$event.stopPropagation(); panelClicked(project, $event)"
								*ngIf="isMultiSelectEnabled"
								[ngClass]="{ 'panel-opened-check-icon': step == i }"
								class="selection"
								matTooltip
							>
								<mat-icon>check_circle</mat-icon>
							</span>
						</div>
					</div>

					<div
						[ngClass]="{
							'py-0-5': cargochief.USER_ID != project.userId,
							'py-4': cargochief.USER_ID == project.userId
						}"
						fxLayout="row"
						fxLayoutGap="2rem"
					>
						<div
							(click)="$event.stopPropagation()"
							fxFlex
							fxLayout="row"
							fxLayoutAlign="start center"
						>
							<div
								[ngClass]="{ 'fw-700': step == i }"
								class="h-100"
								fxFlex
								fxLayoutAlign="start center"
							>
								Project Owner:
							</div>

							<div fxFlex fxLayoutAlign="end center">
								{{ project.ownerName }}
							</div>
						</div>

						<div fxFlex fxLayout="row">
							<div fxFlex>
								<app-user-popover
									(userChanged)="setAssigneeId($event, project)"
									[isEnabled]="project.isAssigneeEnabled"
									[placeholder]="project.assigneePlaceholder"
									[selectedUsers]="project.selectedAssigneeIds"
									[singleselect]="true"
									[usersList]="project.usersList"
								>
								</app-user-popover>
							</div>
						</div>

						<div fxFlex fxLayout="row" fxLayoutAlign="center center">
							<div fxFlex fxLayoutAlign="center center">
								<div
									[ngClass]="{ 'fw-700': step == i }"
									class="h-100"
									fxFlex
									fxLayoutAlign="start center"
								>
									Due Date:
								</div>
								<div fxFlex fxLayoutAlign="end center">
									<mat-form-field
										(click)="$event.stopPropagation()"
										class="custom-form-field"
										floatLabel="never"
									>
										<input
											(click)="picker.open()"
											(dateChange)="inputChanged('dueDate', project)"
											[formControl]="project.dueDateFormControl"
											[matDatepicker]="picker"
											[min]="minimumDueDate"
											matInput
											placeholder="Due Date"
										/>
										<mat-datepicker-toggle
											[for]="picker"
											matSuffix
											tabIndex="-1"
										></mat-datepicker-toggle>
										<mat-datepicker #picker></mat-datepicker>
									</mat-form-field>
								</div>
							</div>
						</div>

						<div fxFlex>
							<div fxLayout="row" fxLayoutAlign="end center">
								<div
									[ngClass]="{ 'fw-700': step == i }"
									class="h-100"
									fxFlex
									fxLayoutAlign="start center"
								>
									Carriers:
								</div>
								<div fxFlex fxLayoutAlign="end center">
									<span
										*ngIf="!utilService.isNullOrUndefined(project.carrierCount)"
										class="pl-2 m-r-1-4"
									>
										<span
											[matBadge]="project.carrierCount"
											[ngClass]="{ 'custom-badge-w-auto': project.carrierCount >= 100 }"
											class="custom-badge position-absolute"
											matBadgeOverlap="false"
										></span>
									</span>
								</div>
							</div>
						</div>
					</div>

					<div *ngIf="step != i" fxLayout="row" fxLayoutGap="2rem">
						<div fxFlex fxLayout="row" fxLayoutAlign="start center">
							<div fxFlex fxLayoutAlign="center center">
								<div
									[ngClass]="{ 'fw-700': step == i }"
									class="h-100"
									fxFlex
									fxLayoutAlign="start center"
								>
									Last Bid:
								</div>
								<div
									(click)="$event.stopPropagation(); submitLastBid(project)"
									class="underline cursor-pointer"
									fxFlex
									fxLayoutAlign="end center"
								>
									<span *ngIf="!utilService.isNullOrUndefined(project.lastBid)">
										{{ project.lastBid / 100 | currency: 'USD':'symbol':'1.0-2' }}
									</span>
									<span
										*ngIf="utilService.isNullOrUndefined(project.lastBid)"
										class="font-size-16"
										fxLayoutAlign="center center"
									>
										<mat-icon
											[inline]="true"
											[matTooltip]="TOOLTIP_MSG.LAST_BID"
											class="primary-text w-inherit"
											matSuffix
											matTooltipClass="custom-tooltip"
										>
											info
										</mat-icon>
									</span>
								</div>
							</div>
						</div>
						<div fxFlex fxLayout="row" fxLayoutAlign="center center">
							<div fxFlex fxLayoutAlign="center center">
								<div
									[ngClass]="{ 'fw-700': step == i }"
									class="h-100"
									fxFlex
									fxLayoutAlign="start center"
								>
									Best Rate:
								</div>
								<div fxFlex fxLayoutAlign="end center">
									<span *ngIf="!utilService.isNullOrUndefined(project.bestRate)">
										{{ project.bestRate / 100 | currency: 'USD':'symbol':'1.0-2' }}
									</span>
									<span
										*ngIf="utilService.isNullOrUndefined(project.bestRate)"
										class="font-size-16"
										fxLayoutAlign="center center"
									>
										<mat-icon
											[inline]="true"
											[matTooltip]="TOOLTIP_MSG.BEST_RATE"
											class="primary-text w-inherit"
											matSuffix
											matTooltipClass="custom-tooltip"
										>
											info
										</mat-icon>
									</span>
								</div>
							</div>
						</div>

						<div fxFlex fxLayout="row" fxLayoutAlign="center center">
							<div
								[ngClass]="{ 'fw-700': step == i }"
								class="h-100"
								fxFlex
								fxLayoutAlign="start center"
							>
								Projected Margin:
							</div>
							<div fxFlex fxLayoutAlign="end center">
								<span *ngIf="!utilService.isNullOrUndefined(GET_PROJECTED_MARGIN(project))">
									{{ GET_PROJECTED_MARGIN(project) | percent: '1.0-0' }}
								</span>
								<span
									*ngIf="utilService.isNullOrUndefined(GET_PROJECTED_MARGIN(project))"
									class="font-size-16"
									fxLayoutAlign="center center"
								>
									<mat-icon
										[inline]="true"
										[matTooltip]="TOOLTIP_MSG.PROJETED_MARGIN"
										class="primary-text w-inherit"
										matSuffix
										matTooltipClass="custom-tooltip"
									>
										info
									</mat-icon>
								</span>
							</div>
						</div>

						<div fxFlex fxLayout="row" fxLayoutAlign="end center">
							<div fxFlex fxLayoutAlign="start center">Weight:</div>
							<div fxFlex fxLayoutAlign="end center">
								<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(project?.weight)"
									>{{ project.weight | number: '1.0-0' }} lbs</span
								>
								<span *ngIf="!IS_NOT_NULL_OR_UNDEFINED(project?.weight)">N/A</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<mat-card-content
				*ngIf="!utilService.isNullOrUndefined(step) && step == i"
				class="font-size-14"
			>
				<div fxFlex>
					<div fxLayout="row" fxLayoutGap="2rem">
						<div (click)="submitLastBid(project)" fxFlex>
							<div class="fw-700" fxFlex fxLayoutAlign="start center">Last Bid:</div>
							<div class="font-size-16 underline cursor-pointer" fxFlex fxLayoutAlign="end center">
								<span *ngIf="!utilService.isNullOrUndefined(project.lastBid)">
									{{ project.lastBid / 100 | currency: 'USD':'symbol':'1.0-2' }}
								</span>
								<span *ngIf="utilService.isNullOrUndefined(project.lastBid)" class="font-size-16">
									<mat-icon
										[inline]="true"
										[matTooltip]="TOOLTIP_MSG.LAST_BID"
										class="primary-text w-inherit"
										matSuffix
										matTooltipClass="custom-tooltip"
									>
										info
									</mat-icon>
								</span>
							</div>
						</div>
						<div fxFlex>
							<div class="fw-700" fxFlex fxLayoutAlign="start center">Best Rate:</div>
							<div fxFlex fxLayoutAlign="end center">
								<span *ngIf="!utilService.isNullOrUndefined(project.bestRate)">
									{{ project.bestRate / 100 | currency: 'USD':'symbol':'1.0-2' }}
								</span>
								<span *ngIf="utilService.isNullOrUndefined(project.bestRate)" class="font-size-16">
									<mat-icon
										[inline]="true"
										[matTooltip]="TOOLTIP_MSG.BEST_RATE"
										class="primary-text w-inherit"
										matSuffix
										matTooltipClass="custom-tooltip"
									>
										info
									</mat-icon>
								</span>
							</div>
						</div>
						<div fxFlex>
							<div class="fw-700" fxFlex fxLayoutAlign="start center">Projected Margin:</div>
							<div class="font-size-16" fxFlex fxLayoutAlign="end center">
								<span *ngIf="!utilService.isNullOrUndefined(GET_PROJECTED_MARGIN(project))">
									{{ GET_PROJECTED_MARGIN(project) | percent: '1.0-0' }}
								</span>
								<span
									*ngIf="utilService.isNullOrUndefined(GET_PROJECTED_MARGIN(project))"
									class="font-size-16"
									fxLayoutAlign="center center"
								>
									<mat-icon
										[inline]="true"
										[matTooltip]="TOOLTIP_MSG.PROJETED_MARGIN"
										class="primary-text w-inherit"
										matSuffix
										matTooltipClass="custom-tooltip"
									>
										info
									</mat-icon>
								</span>
							</div>
						</div>
						<div fxFlex fxLayoutAlign="end center">
							<div class="fw-700" fxFlex fxLayoutAlign="start center">Target Margin: &nbsp;</div>
							<div fxFlex fxLayoutAlign="end center">
								<mat-form-field class="custom-form-field">
									<input
										(blur)="targetMarginUpdated(project)"
										(ngModelChange)="onTargetMarginChange(project)"
										[(ngModel)]="project.targetMargin"
										[ngStyle]="{
											color: project.targetMargin < accountSettings.TARGET_MARGIN ? 'red' : 'black',
											'font-weight':
												project.targetMargin > accountSettings.TARGET_MARGIN ? 'bold' : 'normal'
										}"
										autocomplete="off"
										floatLabel="never"
										mask="separator"
										thousandSeparator=","
										prefix="$"
										suffix=" %"
										matInput
									/>
									<mat-icon
										*ngIf="
											!utilService.isNullOrUndefined(project.targetMargin) &&
											!utilService.isNullOrUndefined(accountSettings.TARGET_MARGIN) &&
											project.targetMargin < accountSettings.TARGET_MARGIN
										"
										[inline]="true"
										[matTooltip]="TOOLTIP_MSG.TARGET_MARGIN(accountSettings.TARGET_MARGIN)"
										class="danger-text w-inherit"
										matSuffix
										matTooltipClass="custom-tooltip"
									>
										info
									</mat-icon>
								</mat-form-field>
							</div>
						</div>
					</div>

					<div class="p-t-1" fxLayout="row" fxLayoutGap="2rem">
						<div fxFlex>
							<div class="fw-700" fxFlex fxLayoutAlign="start center">Commodity:</div>
							<div fxFlex fxLayoutAlign="end center">
								<mat-form-field class="custom-form-field" fxFlexFill>
									<input
										(input)="inputChanged('commodity', project)"
										[(ngModel)]="project.commodity"
										autocomplete="off"
										floatLabel="never"
										fxFlex
										matInput
									/>
								</mat-form-field>
							</div>
						</div>
						<div fxFlex>
							<div class="fw-700" fxFlex fxLayoutAlign="start center">Value:</div>
							<div fxFlex fxLayoutAlign="end center">
								<mat-form-field class="custom-form-field" fxFlexFill>
									<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
										>attach_money</mat-icon
									>
									<input
										(input)="inputChanged('value', project)"
										[(ngModel)]="project.value"
										autocomplete="null"
										floatLabel="never"
										fxFlex
										mask="separator"
										thousandSeparator=","
										prefix="$"
										matInput
									/>
								</mat-form-field>
							</div>
						</div>
						<div fxFlex>
							<div class="fw-700" fxFlex fxLayoutAlign="start end">Max Buy:</div>
							<div fxFlex fxLayoutAlign="end center">
								<mat-form-field class="custom-form-field" fxFlexFill>
									<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
										>attach_money</mat-icon
									>
									<input
										(input)="inputChanged('minRate', project)"
										[(ngModel)]="project.minRate"
										autocomplete="null"
										floatLabel="never"
										fxFlex
										mask="separator"
										thousandSeparator=","
										prefix="$"
										matInput
									/>
								</mat-form-field>
							</div>
						</div>
						<div fxFlex>
							<div class="fw-700" fxFlex fxLayoutAlign="start end">Cust Rate:</div>
							<div fxFlex fxLayoutAlign="end center">
								<mat-form-field class="custom-form-field">
									<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
										>attach_money</mat-icon
									>
									<input
										(input)="inputChanged('maxRate', project)"
										[(ngModel)]="project.maxRate"
										autocomplete="null"
										floatLabel="never"
										mask="separator"
										thousandSeparator=","
										prefix="$"
										matInput
									/>
								</mat-form-field>
							</div>
						</div>
					</div>

					<div class="p-t-1" fxLayout="row" fxLayoutAlign="top left" fxLayoutGap="2rem">
						<div fxFlex>
							<div class="fw-700" fxFlex>
								<div *ngIf="!accountSettings.ANNUAL_VOLUME" class="h-100" fxLayoutAlign="start end">
									Load Volume:
								</div>
								<div
									*ngIf="accountSettings.ANNUAL_VOLUME"
									[matTooltip]="TOOLTIP_MSG.LOAD_VOLUME(project.annualVolumeTooltip)"
									class="h-100"
									fxLayoutAlign="start center"
									matTooltipClass="custom-tooltip"
								>
									Annual Volume:
								</div>
							</div>
							<div fxFlex>
								<div
									*ngIf="!accountSettings.ANNUAL_VOLUME || isEditingAnnualVolume"
									fxLayout="row"
									fxLayoutAlign="start end"
									fxLayoutGap="0.2rem"
								>
									<mat-form-field class="custom-form-field" floatLabel="never" fxFlex>
										<mat-label>Duration</mat-label>
										<mat-select
											(selectionChange)="inputChanged('loadVolumeDuration', project)"
											[(ngModel)]="project.loadVolumeDuration"
											disableOptionCentering
										>
											<mat-option *ngFor="let duration of loadVolumeDuration" [value]="duration">
												{{ duration }}
											</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field class="custom-form-field" floatLabel="never" fxFlex="45">
										<mat-label>Count</mat-label>
										<input
											(input)="inputChanged('loadVolume', project)"
											[(ngModel)]="project.loadVolume"
											autocomplete="off"
											floatLabel="never"
											fxFlex
											mask="separator"
											thousandSeparator=","
											matInput
										/>
									</mat-form-field>
									<mat-icon
										(click)="isEditingAnnualVolume = false"
										*ngIf="isEditingAnnualVolume"
										[inline]="true"
										class="danger-text cursor-pointer"
										matSuffix
									>
										cancel
									</mat-icon>
								</div>
								<div
									*ngIf="accountSettings.ANNUAL_VOLUME && !isEditingAnnualVolume"
									class="h-100"
									fxLayout="row"
									fxLayoutAlign="end center"
									fxLayoutGap="0.2rem"
								>
									{{ project.annualVolumeDisplay }}
									<mat-icon
										(click)="isEditingAnnualVolume = true"
										*ngIf="!isEditingAnnualVolume"
										[inline]="true"
										class="primary-text m-l-1 cursor-pointer edit-volume-icon"
										matSuffix
									>
										edit
									</mat-icon>
								</div>
							</div>
						</div>
						<div fxFlex fxLayoutAlign="center center">
							<div class="fw-700" fxFlex fxLayoutAlign="start end">Days Run:</div>
							<div *ngIf="IS_NOT_EMPTY(project.daysRun)" fxFlex>
								<mat-form-field class="custom-form-field" floatLabel="never" fxFlex>
									<mat-label>Days</mat-label>
									<mat-select
										(selectionChange)="inputChanged('daysRun', project)"
										[(ngModel)]="project.selectedDaysRun"
										disableOptionCentering
										multiple
									>
										<mat-select-trigger>{{ project.selectedDaysRun }}</mat-select-trigger>
										<mat-option *ngFor="let day of DAYS" [value]="day.value">
											{{ day.label }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div *ngIf="!IS_NOT_EMPTY(project.daysRun)" fxFlex fxLayoutAlign="end center">
								{{ project.daysRun }}
							</div>
						</div>
						<div fxFlex fxLayoutAlign="center center">
							<div class="fw-700" fxFlex fxLayoutAlign="start end">Available Loads:</div>
							<div fxFlex fxLayoutAlign="end center">
								<mat-form-field class="custom-form-field">
									<input
										(input)="inputChanged('loadCount', project)"
										[(ngModel)]="project.loadCount"
										autocomplete="null"
										floatLabel="never"
										mask="separator"
										thousandSeparator=","
										matInput
									/>
								</mat-form-field>
							</div>
						</div>
						<div fxFlex fxLayoutAlign="end center">
							<div *ngIf="!accountSettings.ANNUAL_VOLUME" fxFlex>
								<div class="h-100 fw-700" fxFlex fxLayoutAlign="start end">Max Capacity:</div>
								<div fxFlex fxLayoutAlign="end center">
									<mat-form-field class="custom-form-field">
										<input
											(input)="inputChanged('loadCapacity', project)"
											[(ngModel)]="project.loadCapacity"
											autocomplete="null"
											floatLabel="never"
											mask="separator"
											thousandSeparator=","
											matInput
										/>
									</mat-form-field>
								</div>
							</div>
							<div *ngIf="accountSettings.ANNUAL_VOLUME" fxFlex>
								<div class="h-100 fw-700" fxFlex fxLayoutAlign="start center">
									Opportunity Value:
								</div>
								<div fxFlex fxLayoutAlign="end center">
									<span *ngIf="project.opportunityValue !== ''">
										{{ project.opportunityValue | currency: 'USD':'symbol':'1.0-2' }}
									</span>
									<span *ngIf="project.opportunityValue === ''">
										<mat-icon
											[inline]="true"
											[matTooltip]="TOOLTIP_MSG.OPPORTUNITY_VALUE"
											class="primary-text w-inherit"
											matSuffix
											matTooltipClass="custom-tooltip"
										>
											info
										</mat-icon>
									</span>
								</div>
							</div>
						</div>
					</div>

					<div class="py-0-5 mt-8" fxLayout="row" fxLayoutGap="2rem">
						<div class="fw-700" fxFlex="22.5" fxLayoutAlign="start center">Packaging:</div>
						<div fxFlex fxLayoutAlign="end center">
							<app-special-instructions-dialog
								(updatedString)="project.packaging = $event; inputChanged('packaging', project)"
								[displaySecondaryButton]="true"
								[isEditable]="true"
								[layoutAlign]="'star center'"
								[specialInstructions]="project.packaging"
								fxFlex
								modalTitle="Packaging"
								primaryButtonText="Update"
							>
							</app-special-instructions-dialog>
						</div>
					</div>

					<div class="py-0-5" fxLayout="row" fxLayoutGap="2rem">
						<div class="fw-700" fxFlex="22.5" fxLayoutAlign="start center">
							Trailer Requirements:
						</div>
						<div fxFlex fxLayoutAlign="end center">
							<app-special-instructions-dialog
								(updatedString)="
									project.trailerRequirements = $event; inputChanged('trailerRequirements', project)
								"
								[displaySecondaryButton]="true"
								[isEditable]="true"
								[layoutAlign]="'star center'"
								[specialInstructions]="project.trailerRequirements"
								fxFlex
								modalTitle="Trailer Requirements"
								primaryButtonText="Update"
							>
							</app-special-instructions-dialog>
						</div>
					</div>

					<div class="py-0-5" fxLayout="row" fxLayoutGap="2rem">
						<div class="fw-700" fxFlex="22.5" fxLayoutAlign="start center">Shipper Notes:</div>
						<div fxFlex fxLayoutAlign="end center">
							<app-special-instructions-dialog
								(updatedString)="
									project.shipperNotes = $event; inputChanged('shipperNotes', project)
								"
								[displaySecondaryButton]="true"
								[isEditable]="true"
								[layoutAlign]="'star center'"
								[specialInstructions]="project.shipperNotes"
								fxFlex
								modalTitle="Shipper Notes"
								primaryButtonText="Update"
							>
							</app-special-instructions-dialog>
						</div>
					</div>

					<div class="py-0-5" fxLayout="row" fxLayoutGap="2rem">
						<div class="fw-700" fxFlex="22.5" fxLayoutAlign="start center">Receiver Notes:</div>
						<div fxFlex fxLayoutAlign="end center">
							<app-special-instructions-dialog
								(updatedString)="
									project.receiverNotes = $event; inputChanged('receiverNotes', project)
								"
								[displaySecondaryButton]="true"
								[isEditable]="true"
								[layoutAlign]="'star center'"
								[specialInstructions]="project.receiverNotes"
								fxFlex
								modalTitle="Receiver Notes"
								primaryButtonText="Update"
							>
							</app-special-instructions-dialog>
						</div>
					</div>

					<div class="py-0-5" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="1rem">
						<mat-form-field
							(click)="$event.stopPropagation()"
							class="custom-form-field"
							floatLabel="never"
							fxFlex="10"
						>
							<mat-label>Position</mat-label>
							<mat-select
								(selectionChange)="inputChanged('position', project)"
								[(ngModel)]="project.position"
							>
								<mat-option *ngFor="let position of PROJECT_POSITIONS" [value]="position.value">
									{{ position.label }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>

					<div class="py-0-5" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="1rem">
						<app-request-for-proposal
							(updatedData)="rfpCompleted($event, project.id)"
							[buttonText]="'CHECK CAPACITY'"
							[numberOfCarriers]="project.carrierCount"
							[projectDTO]="getProjectDTOById(project.id)"
						></app-request-for-proposal>
						<button (click)="navigateToProjectDetails(project)" color="primary" mat-raised-button>
							OPTIONS
						</button>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>

<div
	*ngIf="
		!utilService.isNullOrUndefined(numberOfProjects) && !utilService.isNullOrUndefined(PAGE_SIZE)
	"
	fxLayout="row"
	fxLayoutAlign="top left"
>
	<mat-paginator
		(page)="getPaginatorData($event)"
		*ngIf="numberOfProjects > PAGE_SIZE"
		[length]="numberOfProjects"
		[pageSizeOptions]="[PAGE_SIZE]"
		class="mat-elevation-z1 m-t-1"
		fxFlex
	>
	</mat-paginator>
</div>
